import styled from "styled-components";

import {
  flex,
  drawDebug,
  breakpoints
} from "../helpers";
import {
  HedronProviderProps,
  withBreakpoints
} from "./Provider";
import Base from "./Base";

export interface HedronBoundsProps extends HedronProviderProps {
  /**
   * Enable if you want the geometry of the grid exposed
   */
  debug: boolean;

  /**
   * Interface for setting the `flex` css property
   */
  flex: string;

  /**
   * The primary axis the children should be in line with
   */
  direction: "horizontal" | "vertical";

  /**
   * Whether children should wrap when there's no more room
   * on the primary axis.
   */
  allowWrap: boolean;

  /**
   * Alignment of children along the vertical axis
   */
  valign: "top" | "center" | "bottom" | null;

  /**
   * Alignment of children along the horizontal axis
   */
  halign: "left" | "center" | "right" | null;
}

/**
 * Bounds functions as a container to wrap `Box` components.
 * The only components that should be a direct children of `Bounds`
 * are `Box` or `Bounds`.
 */
export const Bounds = styled(Base("div"))<HedronBoundsProps>`
  box-sizing: border-box;
  display: flex;
  ${props => props.debug && drawDebug()};
  ${props => flex(props)};
  ${props => breakpoints(props)};
`;

Bounds.defaultProps = {
  debug: false,
  direction: "horizontal",
  allowWrap: false
};

export default withBreakpoints(Bounds);
